import { CURATED_PICKS_TYPE } from '../../../utils/constants/CuratedPickTypes';
import {
  EVENT_VENUE_TYPE,
  FILTER_TYPES,
} from '../../../utils/constants/FilterTypes';
import { SIGNATURE_COLLECTION_TEXT } from '../../../assets/copy';
import filterResults from '../../../utils/filterResults';
import { select } from 'redux-saga/effects';
import {
  getFeatureFlags,
} from '../../../utils/useFeatureFlags';

export function* getVenuesByCuratedPick(results) {
  let venuesByCuratedPick = [];
  const { refreshSearchRevampFlagIsEnabled } = yield select(getFeatureFlags);
  if (refreshSearchRevampFlagIsEnabled) {
    const categories = yield select((state) => state.categories);
    for (const curatedPick of Object.values(CURATED_PICKS_TYPE)) {
      const filters = getFilterForCuratedPick(curatedPick, categories);
      const resultItems = filterResults(filters, results);
      if (resultItems.length > 0) {
        venuesByCuratedPick.push({
          curatedPickType: curatedPick,
          venues: resultItems,
        });
      }
    }
  }
  return venuesByCuratedPick;
}

/**
 * @returns {Object.<string, any[]>}
 */
export function getFilterForCuratedPick(curatedPick, categories) {
  switch (curatedPick) {
    case CURATED_PICKS_TYPE.SIGNATURE_COLLECTION:
      return {
        [FILTER_TYPES.CATEGORIES]: categories?.list.filter(
          (category) => category.name === SIGNATURE_COLLECTION_TEXT
        ),
      };
    case CURATED_PICKS_TYPE.EVENTS:
      return {
        [FILTER_TYPES.VENUE_TYPE]: [
          {
            [FILTER_TYPES.VENUE_TYPE]: EVENT_VENUE_TYPE.venueType,
          },
        ],
      };
    case CURATED_PICKS_TYPE.DATE_NIGHT:
    case CURATED_PICKS_TYPE.BRUNCH:
    case CURATED_PICKS_TYPE.OUTDOOR:
    case CURATED_PICKS_TYPE.SPECIAL_EVENTS:
    case CURATED_PICKS_TYPE.BIG_GROUPS:
      return {
        [FILTER_TYPES.OCCASIONS]: [
          {
            id: curatedPick,
          },
        ],
      };
    default:
      return {};
  }
}
